/** „Server als gelesen markieren": POST /servers/:id/ack (Vertrag 4.3) und lokal sofort übernehmen. */
import { errorMessage } from '../../lib/api';
import { serversApi } from '../../lib/endpoints';
import { useAppStore } from '../../store/app';
import { toast } from '../../store/ui';

export function markServerRead(serverId: string): void {
  serversApi.ack(serverId).catch((e: unknown) => toast.error('Fehler', errorMessage(e)));
  useAppStore.getState().update((d) => {
    for (const c of Object.values(d.channels)) {
      if (c.serverId === serverId && c.lastMessageId) {
        d.readStates[c.id] = { channelId: c.id, lastReadMessageId: c.lastMessageId, mentionCount: 0, lastPinAt: d.readStates[c.id]?.lastPinAt ?? null };
      }
    }
  });
}
